import React, { useContext, useState } from "react";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContext } from "../../context/ToastContext";
import { uploadCar } from "../../_services/carsService";
import DynamicBulletInput from "./DynamicInput";
import ImageUploader from "./ImageUploader";
import DatePickerYearsOrder from "./YearPicker";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa'; // FontAwesome info icon

// Dropdown options
const carMakes = [
  "Toyota",
  "Honda",
  "Ford",
  "BMW",
  "Mercedes",
  "Audi",
  "Nissan",
  "Hyundai",
  "Kia",
  "Tesla",
];
const bodyTypes = [
  "Sedan",
  "SUV",
  "Hatchback",
  "Convertible",
  "Truck",
  "Van",
  "Coupe",
];
const fuelTypes = ["Petrol", "Diesel", "Electric", "Hybrid"];
const transmissions = ["Manual", "Automatic", "CVT"];
const drivetrains = ["FWD", "RWD", "AWD", "4WD"];
const featuresList = [
  "Sunroof",
  "Leather Seats",
  "Backup Camera",
  "Bluetooth",
  "Cruise Control",
  "Navigation",
  "Heated Seats",
];

const SellCarPage = ({ }) => {
  const [imagePreviews, setImagePreviews] = useState([]);
  const [displayImage, setDisplayImage] = useState([]);
  const [exteriorImages, setExteriorImages] = useState([]);
  const [interiorImages, setInteriorImages] = useState([]);
  const [ownershipDocuments, setOwnershipDocuments] = useState([]);


  
  const [videoPreview, setVideoPreview] = useState(null);
  const { showToast } = useContext(ToastContext);


  
  const initialValues = {
    make: "",
    model: "",
    manufacturing_year: "",
    reg_year: "",
    mileage: "",
    engine_cap: "",
    power: "",
    curb_weight: "",
    odometer_reading: "",
    engine: "",
    color: "",
    color: "",
    body_type: "",
    fuel_type: "",
    transmission:"",
    drive_train:"",
    price:"",
    num_owners:"",
    coe:"",
    omv:"",
    arf:"",
    car_price: "",
    quote_price: "",
    depreciation:"",
    dereg_value:"",
    road_tax: "",
    display_image: [],
    exterior_images: [],
    interior_images: [],
    ownership_images: [],
    video: ""
  };

  const validationSchema = Yup.object({
    make: Yup.string().required("Required"),
    model: Yup.string().required("Required"),
  /*
    manufactured: Yup.number()
      .required("Required")
      .min(1900)
      .max(new Date().getFullYear()),
    regdate: Yup.number()
      .required("Required")
      .min(1900)
      .max(new Date().getFullYear()),
    */
    
   // vin: Yup.string().required("Required"),
   price: Yup.number().moreThan(0,"Price should be greater than 1"),
   power: Yup.number().moreThan(0,"Price should be greater than 1"),
   odometer_reading: Yup.number().moreThan(0,"odometer should be greater than 1")
    //body_type: Yup.string().required("Required"),
    //fuel_type: Yup.string().required("Required"),
    //engine: Yup.string().required("Required"),
    //transmission: Yup.string().required("Required"),
    //drivetrain: Yup.string().required("Required"),
    //color: Yup.string().required("Required"),
    //quoted_price: Yup.number().required("Required"),
   // features: Yup.string().required("Required"),
    //images: Yup.mixed().required("Required"),
    //video: Yup.mixed(),
    //user_name: Yup.string().required("Required"),
    //user_email: Yup.string().email("Invalid email").required("Required"),
    // user_phone_number: Yup.string().required("Required"),
    // user_address: Yup.string().required("Required"),
  });

  const handleFeatureChange = (event, selectedFeatures, setFieldValue) => {
    const { checked, value } = event.target;

    let updatedFeatures = [...selectedFeatures]; // Clone the existing selected features

    if (checked) {
      updatedFeatures.push(value);
    } else {
      updatedFeatures = updatedFeatures.filter((feature) => feature !== value);
    }

    setFieldValue("features", updatedFeatures.join(",")); // Convert to a comma-separated string
  };

  const handleImageChange = (event, setFieldValue,fieldName) => {
    const files = Array.from(event.currentTarget.files);
    if (files.length) {
      setImagePreviews(files.map((file) => URL.createObjectURL(file)));
      setFieldValue(fieldName, files);
    }
  };

  const handleSectionChange = (index, items, description) => {
    setSectionsData(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        items,
        description,
      };
      return updated;
    });
  };
  
  

  const handleDisplayImageChange = (event, setFieldValue,fieldName) => {
    const files = Array.from(event.currentTarget.files);
    if (files.length) {
      setDisplayImage(files.map((file) => URL.createObjectURL(file)));
      setFieldValue(fieldName, files);
    }
  };
  const handleExteriorImageChange = (event, setFieldValue,fieldName) => {
    const files = Array.from(event.currentTarget.files);
    if (files.length) {
      setExteriorImages(files.map((file) => URL.createObjectURL(file)));
      setFieldValue(fieldName, files);
    }
  };
  const handleInteriorImageChange = (event, setFieldValue,fieldName) => {
    const files = Array.from(event.currentTarget.files);
    if (files.length) {
      setInteriorImages(files.map((file) => URL.createObjectURL(file)));
      setFieldValue(fieldName, files);
    }
  };

  const handleOwnershipDocumentsChange = (event, setFieldValue,fieldName) => {
    const files = Array.from(event.currentTarget.files);
    if (files.length) {
      setOwnershipDocuments(files.map((file) => URL.createObjectURL(file)));
      setFieldValue(fieldName, files);
    }
  };

  const handleVideoChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    if (file) {
      setVideoPreview(URL.createObjectURL(file));
      setFieldValue("video", file);
    }
  };

  const handleCarUpload = async (formData) => {
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }
    try {
      await uploadCar(formData);
      showToast("Car uploaded successfully!", "success");
    } catch (error) {
          showToast("Error uploading car", "danger");
    }
  };

  const [sectionsData, setSectionsData] = useState([
    {
      title: "Highlights",
      placeholder: "highlights",
      fieldName: "highlights",
      items: [],
      description: '',
    },
    {
      title: "Equipment List",
      placeholder: "Equipment item",
      fieldName: "equipments",
      items: [],
      description: '',
    },
    {
      title: "Modification",
      placeholder: "Modification",
      fieldName: "modification",
      items: [],
     description: '',
    },
    {
      title: "Known Flaws",
      placeholder: "Known Flaws",
      fieldName: "known_flaws",
      items: [],
    description: '',
    },
    {
      title: "Recent Service History",
      placeholder: "Recent Service History",
      fieldName: "service_history",
      items: [],
    description: '',
    },
    {
      title: "Other Items Included in Sale",
      placeholder: "Other Items Included in Sale",
      fieldName: "other_items",
      items: [],
    description: '',
    },
    {
      title: "Ownership History",
      placeholder: "Ownership History",
      fieldName: "ownership_history",
      items: [],
    description: '',
    },
    {
      title: "Seller Notes",
      placeholder: "Seller Notes",
      fieldName: "seller_notes",
      items: [],
    description: '',
    }
  ]);
  const resetSections = () => {
    sectionsData.forEach((section) => {
      section.items = [];
      section.description = '';
    });
  };
  const resetImages = () => {
    setDisplayImage([]);
    setExteriorImages([]);
    setInteriorImages([]);
    setOwnershipDocuments([]);
  };

  const removeImage = (index) => {
    const updatedImages = [...exteriorImages];
    updatedImages.splice(index, 1);
    setExteriorImages(updatedImages);
    //setFieldValue('exterior_images', updatedImages); // Keep Formik in sync
  };

  const removeDisplayImage = (index) => {
    const updatedImages = [...displayImage];
    updatedImages.splice(index, 1);
    setDisplayImage(updatedImages);
    //setFieldValue('display_image', updatedImages); // if you're syncing with Formik
  };

  const removeItem = (index, items, setItems, fieldName, setFieldValue) => {
    const updated = [...items];
    updated.splice(index, 1);
    setItems(updated);
  
    // Update Formik field too
    setFieldValue(fieldName, (prev) => {
      if (Array.isArray(prev)) {
        const newVal = [...prev];
        newVal.splice(index, 1);
        return newVal;
      }
      return null;
    });
  };
  
  
  const handleFileChange = (event, setFieldValue, setPreviewState, fieldName, values,multiple = false,) => {
    const files = Array.from(event.target.files);
    const previews = files.map(file => URL.createObjectURL(file));
  
    if (multiple) {
      // Update previews
      setPreviewState((prev) => [...prev, ...previews]);
  
      const existing = values[fieldName] || [];
      setFieldValue(fieldName, [...existing, ...files]);
     
    } else {
      // Single image upload
      setPreviewState(previews);
      setFieldValue(fieldName, files[0]);
    }
  
    event.target.value = null; // clear the input
  };
  



  return (
    <div className="container mt-5 mb-md-4 py-5">
      <div className="row">
        {/* <!-- Page content--> */}
        <div className="col-lg-8">
    
          {/* <!-- Title--> */}
          <div className="mb-4">
            
            <div className="d-lg-none  pt-3 mb-2">80% content filled</div>
            <div
              className="progress d-lg-none mb-4"
              style={{
                height: ".25rem",
              }}
            >
              <div
                className="progress-bar bg-success"
                role="progressbar"
                style={{ width: "80%" }}
                aria-valuenow="80"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          {/* <!-- Basic info--> */}

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              // resetForm();
              const formData = new FormData();

              // Append all form fields
              const appendFiles = (key, files) => {
                if (files && files.length > 0) {
                  for (let i = 0; i < files.length; i++) {
                    if (files[i] instanceof File) {
                      formData.append(key, files[i]);
                    }
                    
                  }
                }
              };
          
              // Iterate through the form fields and append them to FormData
              Object.keys(values).forEach((key) => {
                if (key === "display_image") {
                  appendFiles("display_image", values.display_image);
                } else if (key === "exterior_images") {
                  appendFiles("exterior_images", values.exterior_images);
                } else if (key === "interior_images") {
                  appendFiles("interior_images", values.interior_images);
                } else if (key === "ownership_images") {
                  appendFiles("ownership_images", values.ownership_images);
                } else if (key === "video") {
                  if (values.video) {
                    formData.append("video", values.video);
                  }
                } else {
                  // Append other fields if they are not empty
                  if (values[key] && values[key] !== "") {
                    formData.append(key, values[key]);
                  }
                }
              });
              const dynamicSections = {};
            sectionsData.forEach((section) => {
              dynamicSections[section.fieldName] = {
                description: section.description,
                items: section.items
                  .map((item) => item.trim())
                  .filter((item) => item),
              };
            });

            // 3. Append the dynamicSections object as a single JSON string
            formData.append("sections", JSON.stringify(dynamicSections));

              // Merge regular form values with dynamic sections
              
              handleCarUpload(formData);
              resetSections(); // Reset dynamic sections (e.g., the items and descriptions)
              resetImages();
              setSubmitting(false);
              resetForm();
            }}
          >
            {({ values, setFieldValue, validateForm, submitForm, setTouched }) => (
              <FormikForm>
                <section
                  className="card card-body border-0 bg-gray p-4 mb-4"
                  id="basic-info"
                >
                  <h1 className="h5  mb-4">Basic Information</h1>
                  <Row>
                    {/* Car Make Dropdown */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Make</Form.Label>
                        <Field className="form-control" name="make" />
                        <ErrorMessage
                          name="make"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>

                    {/* Model */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Model</Form.Label>
                        <Field className="form-control" name="model" />
                        <ErrorMessage
                          name="model"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>

                    {/* Other Fields */}
                    {[
                      { name: "manufacturing_year", label: "Manufactured Year", type: "number",tooltip: "Year of manufacturing of your vehicle" },
                      { name: "reg_year", label: "Reg. Year", type: "number" ,tooltip: "Year of registration of your vehicle"},
                      { name: "mileage", label: "Mileage", type: "number" },
                      { name: "engine_cap", label: "EngineCap(cc)", type: "number" },
                      { name: "power", label: "Power(bhp)", type: "number" },
                      { name: "curb_weight", label: "Curb Weight(kg)", type: "number" },
                      {name: "odometer_reading",label: "Odometer Reading",type: "number"},
                      { name: "engine", label: "Engine", type: "text" },
                      { name: "color", label: "Color", type: "text" },
                    ].map((field, index) => (
                      <Col md={6} key={index}>
                        <Form.Group className="mb-3">
                          <Form.Label className="d-flex align-items-center">
                            {field.label}
                            {field.tooltip && (
                              <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip>{field.tooltip}</Tooltip>}
                              >
                                <span style={{ marginLeft: '6px', cursor: 'pointer', color: 'grey' }}>
                                  <FaInfoCircle size={14} />
                                </span>
                              </OverlayTrigger>
                            )}
                            </Form.Label>
                          {field.name === "manufacturing_year" || field.name === "reg_year" ? (
                              <DatePickerYearsOrder
                                name={field.name} // Pass the field name so you can connect it later
                              />
                            )  : (
                            <Field
                              className="form-control"
                              name={field.name}
                              type={field.type}
                              {...(field.type === 'number' ? { min: 1 } : {})}
                            />
                          )}
                          <ErrorMessage
                            name={field.name}
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                    ))}



                    {/* Select Fields */}
                    {[
                      {
                        name: "body_type",
                        label: "Body Type",
                        options: bodyTypes,
                      },
                      {
                        name: "fuel_type",
                        label: "Fuel Type",
                        options: fuelTypes,
                      },
                      {
                        name: "transmission",
                        label: "Transmission",
                        options: transmissions,
                      },
                      {
                        name: "drive_train",
                        label: "Drivetrain",
                        options: drivetrains,
                      }
                    ].map((field, index) => (
                      <Col md={6} key={index}>
                        <Form.Group className="mb-3">
                          <Form.Label>{field.label}</Form.Label>
                          <Field
                            as="select"
                            className="form-select"
                            name={field.name}
                          >
                            <option value="">Select {field.label}</option>
                            {field.options.map((option, idx) => (
                              <option key={idx} value={option}>
                                {option}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name={field.name}
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                    ))}
                    
                  </Row>
                </section>
              
                <section
                  className="card card-body border-0 bg-gray p-4 mb-4"
                  id="vehicle-ownership"
                >
                    <h1 className="h5  mb-4 ">Vehicle Ownership and Cost Components</h1>
                  <Row>
                  
                  {[
                      { name: "num_owners", label: "No. of Owners", type: "number",tooltip: "Total number of owners" },
                      { name: "coe", label: "COE ($)", type: "number",tooltip: "Certificate of entitlement" },
                      { name: "omv", label: "OMV ($)", type: "number",tooltip: "Open market value. Value of the car before any tax, duties" },
                      { name: "arf", label: "ARF ($)", type: "number",tooltip: "A tax you pay when registering a car, based on the OMV" },
                      { name: "depreciation", label: "Depreciation ($)", type: "number" },
                      { name: "road_tax", label: "Road Tax ($)", type: "number" },
                      { name: "car_price", label: "Price of the car ($)", type: "number",tooltip: "Price of the car when you bought" },
                      { name: "quote_price", label: "How much you would like to quote? ($)", type: "number",tooltip: "Enter your desired quote price. XLR8 will assess the car and supporting documents to determine an appropriate final price. Upon agreement, your car will be listed for auction on the XLR8 platform."  }
                      
                    ].map((field, index) => (
                      <Col md={6} key={index}>
                        <Form.Group className="mb-3">
                          <Form.Label className="d-flex align-items-center">
                          {field.label}
                          {field.tooltip && (
                            <OverlayTrigger
                              placement="right"
                              overlay={<Tooltip>{field.tooltip}</Tooltip>}
                            >
                              <span style={{ marginLeft: '6px', cursor: 'pointer', color: 'grey' }}>
                                <FaInfoCircle size={14} />
                              </span>
                            </OverlayTrigger>
                          )}
                        </Form.Label>
                          <Field
                            className="form-control"
                            name={field.name}
                            type={field.type}
                            {...(field.type === 'number' ? { min: 1 } : {})}
                          />
                          <ErrorMessage
                            name={field.name}
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                   
                    ))}
                  </Row>
                </section>
               
                <section
                  className="card card-body border-0 bg-gray p-4 mb-4"
                  id="basic-info"
                >
                   <h1 className="h5  mb-4">Car Visuals & Documents</h1>
                  {/* File Uploads */}
                  <ImageUploader
                      label="Display Image"
                      name="display images"
                      multiple={false}
                      images={displayImage}
                      onChange={(e) =>
                        handleFileChange(e, setFieldValue, setDisplayImage, "display_image", values,false)
                      }
                      onRemove={(idx) =>
                        removeItem(idx, displayImage, setDisplayImage, "display_image", setFieldValue)
                      }
                      status='true'
                    />


                  <ImageUploader
                    label="Exterior Images"
                    name="exterior_images"
                    multiple={true}
                    images={exteriorImages}
                    onChange={(e) =>
                      handleFileChange(e, setFieldValue, setExteriorImages, "exterior_images", values,true)
                    }
                    onRemove={(idx) =>
                      removeItem(idx, exteriorImages, setExteriorImages, "exterior_images", setFieldValue)
                    }
                     status='true'
                  />


                  <ImageUploader
                    label="Interior Images"
                    name="interior_images"
                    multiple={true}
                    images={interiorImages}
                    onChange={(e) =>
                      handleFileChange(e, setFieldValue, setInteriorImages, "interior_images",values, true)
                    }
                    onRemove={(idx) =>
                      removeItem(idx, interiorImages, setInteriorImages, "interior_images", setFieldValue)
                    }
                     status='true'
                  />

                  <ImageUploader
                      label="Ownership & Service Images"
                      name="ownership_images"
                      multiple={true}
                      images={ownershipDocuments}
                      onChange={(e) =>
                        handleFileChange(e, setFieldValue, setOwnershipDocuments, "ownership_images", values,true,ownershipDocuments)
                      }
                      onRemove={(idx) =>
                        removeItem(idx, ownershipDocuments, setOwnershipDocuments, "ownership_images", setFieldValue)
                      }
                       status='true'
                  />

                  <Form.Group className="mb-3 mt-2">
                    <Form.Label>Car Video</Form.Label>
                    <Form.Control
                      type="file"
                      accept="video/*"
                      onChange={(e) => handleVideoChange(e, setFieldValue)}
                    />
                    {videoPreview && (
                      <video controls width="100%" className="mt-2">
                        <source src={videoPreview} type="video/mp4" />
                      </video>
                    )}
                  </Form.Group>
                </section>
                {sectionsData.map((section, index) => (
                  <section key={index} className="card border-0 bg-gray card-body p-4 mb-4">
                    <DynamicBulletInput
                      title={section.title}
                      placeholder={section.placeholder}
                      items={section.items}
                      description={section.description}
                      onChange={(items, description) => handleSectionChange(index, items, description)}
                      maxItems={10}
                    />
                  </section>
                ))}
                

                

                {/* Submit */}
                <div className="d-sm-flex justify-content-between pt-2">
                  <a
                    className="btn btn-outline-light btn-lg d-block mb-3 mb-sm-2"
                    href="#preview-modal"
                    data-bs-toggle="modal"
                  >
                    <i className="fi-eye-on ms-n1 me-2"></i>Preview
                  </a>
                  <Button
                  
                    variant="primary"
                    onClick={async () => {
                      const errors = await validateForm();
                      if (Object.keys(errors).length > 0) {
                        setTouched(
                          Object.keys(errors).reduce(
                            (acc, key) => ({ ...acc, [key]: true }),
                            {}
                          )
                        );
                        // Scroll to the first field with an error
                      const firstErrorKey = Object.keys(errors)[0];
                      const errorElement = document.querySelector(`[name="${firstErrorKey}"]`);

                      if (errorElement) {
                        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
                        errorElement.focus();
      }
                        showToast("Please fill up the mandatory fields",'danger');
                      } else {
                        submitForm();
                      }
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </FormikForm>
            )}
          </Formik>
        </div>
        {/* <!-- Progress of completion--> */}
        <aside className="col-lg-3 offset-lg-1 d-none d-lg-block">
          <div className="sticky-top pt-5">
            <h6 className=" pt-5 mt-3 mb-2">80% content filled</h6>
            <div
              className="progress progress-light mb-4"
              style={{ height: ".25rem" }}
            >
              <div
                className="progress-bar bg-success"
                role="progressbar"
                style={{ width: "80%" }}
                aria-valuenow="80"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <ul className="list-unstyled">
              <li className="d-flex align-items-center">
                <i className="fi-check text-primary me-2"></i>
                <a
                  className="nav-link ps-1"
                  href="#basic-info"
                  data-scroll
                  data-scroll-offset="20"
                >
                  Basic info
                </a>
              </li>
              <li className="d-flex align-items-center">
                <i className="fi-check text-primary me-2"></i>
                <a
                  className="nav-link ps-1"
                  href="#price"
                  data-scroll
                  data-scroll-offset="20"
                >
                  Price
                </a>
              </li>
              <li className="d-flex align-items-center">
                <i className="fi-check text-primary me-2"></i>
                <a
                  className="nav-link ps-1"
                  href="#vehicle-info"
                  data-scroll
                  data-scroll-offset="20"
                >
                  Vehicle information
                </a>
              </li>
              <li className="d-flex align-items-center">
                <i className="fi-check  opacity-60 me-2"></i>
                <a
                  className="nav-link ps-1"
                  href="#features"
                  data-scroll
                  data-scroll-offset="20"
                >
                  Features
                </a>
              </li>
              <li className="d-flex align-items-center">
                <i className="fi-check  opacity-60 me-2"></i>
                <a
                  className="nav-link ps-1"
                  href="#photos"
                  data-scroll
                  data-scroll-offset="20"
                >
                  Photos / video
                </a>
              </li>
              <li className="d-flex align-items-center">
                <i className="fi-check text-primary me-2"></i>
                <a
                  className="nav-link ps-1"
                  href="#location"
                  data-scroll
                  data-scroll-offset="20"
                >
                  Location
                </a>
              </li>
              <li className="d-flex align-items-center">
                <i className="fi-check text-primary me-2"></i>
                <a
                  className="nav-link ps-1"
                  href="#contacts"
                  data-scroll
                  data-scroll-offset="20"
                >
                  Contacts
                </a>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default SellCarPage;
